const MatchBadgeIcon = () => {
  return (
    <svg
      width="28"
      height="21"
      viewBox="0 0 28 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="28" height="20" rx="10" fill="#407BFF" />
      <mask
        id="mask0_12310_105283"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="4"
        width="12"
        height="13"
      >
        <rect x="8" y="4.5" width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12310_105283)">
        <path
          d="M17.5 9L16.875 7.625L15.5 7L16.875 6.375L17.5 5L18.125 6.375L19.5 7L18.125 7.625L17.5 9ZM17.5 16L16.875 14.625L15.5 14L16.875 13.375L17.5 12L18.125 13.375L19.5 14L18.125 14.625L17.5 16ZM12.5 14.5L11.25 11.75L8.5 10.5L11.25 9.25L12.5 6.5L13.75 9.25L16.5 10.5L13.75 11.75L12.5 14.5ZM12.5 12.075L13 11L14.075 10.5L13 10L12.5 8.925L12 10L10.925 10.5L12 11L12.5 12.075Z"
          fill="#C6D7FF"
        />
      </g>
    </svg>
  )
}

export default MatchBadgeIcon
